import { render } from "./notes-polygon.vue?vue&type=template&id=63773946"
import script from "./notes-polygon.vue?vue&type=script&lang=js"
export * from "./notes-polygon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utente\\Documents\\politecnico\\anno4\\semestre1\\actam\\xenboard-actm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__